export const DEFAULT_CKEDITOR_CONFIG = {
  extraPlugins: 'divarea,font,justify,colordialog,dialog,dialogui,button,colorbutton,floatpanel,panel,panelbutton,tabletools,table',
  height: 500
};
